var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6654 6.92097L25.7168 2.97243C24.0497 1.30175 21.8279 0.356733 19.4869 0.220728C19.372 2.35207 17.4047 4.05433 15.0031 4.05433C12.6015 4.05433 10.6369 2.3547 10.5193 0.225992C8.12385 0.379547 5.93724 1.32106 4.28324 2.97418L0.334689 6.92273C-0.0917536 7.34917 -0.0917537 7.88266 0.22764 8.30911L4.49383 13.6423C4.8141 13.8555 5.13437 14.0687 5.34759 14.0687C5.66275 14.0772 5.96876 13.9622 6.20047 13.7484L7.58773 12.3621V24.7342C7.58773 25.3747 8.01417 25.8012 8.65384 25.8012H21.4533C22.0929 25.8012 22.5194 25.3747 22.5194 24.7342V12.3621L23.9058 13.7484C24.1378 13.9622 24.4441 14.0771 24.7595 14.0687C25.0789 14.0687 25.2921 13.8555 25.5062 13.6423L29.7724 8.30911C30.0918 7.88091 30.0918 7.34742 29.6654 6.92097Z",
    fill: "#688060"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0005 3.17863C16.923 3.17863 18.4989 1.86244 18.6068 0.20581C18.4277 0.216442 18.2537 0.269778 18.0994 0.361365C17.945 0.452952 17.8149 0.580131 17.7197 0.732283C17.1862 1.69222 16.228 2.33188 15.0531 2.33188C13.8782 2.33188 12.92 1.69222 12.2804 0.732283C12.0671 0.412012 11.7469 0.198792 11.4266 0.198792H11.3924C11.5021 1.85894 13.0753 3.17863 15.0005 3.17863Z",
    fill: "#688060"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.ef53fe810fd29cd7f5f3de7cee9338d2.svg";
export { ForwardRef as ReactComponent };